<template>
  <div class="cont_body">
    <div class="list_cont">
      <div class="list_img">
        <img :src="getImg(optionsData.img)" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{optionsData.productName}} <span>· <dict-render :dict-obj="dictObjs['paymentType']"
          :text="optionsData.paymentType"></dict-render></span></h4>
        <div class="list_cont_mid">
          <p>
            <span>贷款额度：<i>{{optionsData.maxLoanLines}}</i>万元</span>
            <span>贷款利率：<i>{{optionsData.rate}}</i></span>
            <span>担保方式：<i><dict-render :dict-obj="dictObjs['guarantee']"
              :text="optionsData.guarantyType"></dict-render></i></span>
          </p>
        </div>
        <!-- <div class="list_cont_end">
          <a-tag v-for="(item,key) in optionsData.investmentField.split()" :key="key">
            <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item"></dict-render>
          </a-tag>
        </div> -->
      </div>
      <div class="list_botton">
        <a-button v-if="role=='company'" size="large" @click="onAdd" style="width:120px;" >立即申请</a-button>
      </div>
    </div>
    <div class="list_bottom">
      <h4>产品详情</h4>
      <p v-html="optionsData.details">

      </p>
    </div>
  </div>
  <a-modal width="700px" title="申请贷款" v-model:visible="visible" :maskClosable="false" :closable="false"  @ok="onSubmit" @cancel="handleCancel">
    <a-form :labelCol="{span:6}" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
        <a-row :gutter="[24,8]">
          <a-col :span="24">
              <div class="hidden">
                  <a-form-item label="金融机构id" name="mechanismId">
                      <a-input v-model:value="form.mechanismId" placeholder="请输入金融机构id" />
                  </a-form-item>
                  <a-form-item label="产品id" name="productId">
                      <a-input v-model:value="form.productId" placeholder="请输入产品id" />
                  </a-form-item>
                  <a-form-item label="企业code" name="companyCode">
                      <a-input v-model:value="form.companyCode" placeholder="请输入企业code" />
                  </a-form-item>
              </div>
              <a-form-item :labelCol='{span:4}' label="联系人姓名" name="contact">
                  <a-input v-model:value="form.contact" placeholder="请输入联系人姓名" />
              </a-form-item>
              <a-form-item :labelCol='{span:4}' label="联系人电话" name="contactNumber">
                  <a-input v-model:value="form.contactNumber" placeholder="请输入联系人电话" />
              </a-form-item>
              <a-form-item :labelCol='{span:4}' label="申请贷款额度（万元）" name="loanAmount">
                <a-input-number style="width:100%" v-model:value="form.loanAmount" placeholder="请输入申请贷款额度（万元）" />
            </a-form-item>
              <a-form-item :labelCol='{span:4}' label="申请备注" name="applicationRemarks">
                  <a-textarea v-model:value="form.applicationRemarks" placeholder="请输入申请备注"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
              </a-form-item>
          </a-col>
        </a-row>
    </a-form>
</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { dictMixin,formMixin } from "@/mixins";
import {financeProductWeb,financeLoan} from "@/api/finance";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin,formMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dictNames: 'paymentType,guarantee',
      optionsData:null,
      lists: [],
      visible:false,
      role: null,
      form: {
          companyCode: null,
          productId: null,
          mechanismId: null,
          contact: null,
          contactNumber: null,
          loanAmount: null,
          applicationRemarks: null,
          processingState: null,
      },
      rules: {
          companyCode: [dataCheck.required({})],
          productId: [],
          mechanismId: [],
          loanAmount: [dataCheck.required({type:'number'}),dataCheck.number],
          contact: [dataCheck.required({})],
          contactNumber: [dataCheck.required({})],
          processingState: [dataCheck.required({})],
          applicationRemarks: [],
      },
    }
  },
  computed: {
      submitUrl() {
          return financeLoan.add
      }
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: financeProductWeb.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
        this.form.mechanismId = res.institutionsId
        this.form.productId = res.id
        this.form.companyCode = this.$ls.get('companyCode')
        this.role = this.$ls.get('roleCode').split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })
      })
    }
  },
	methods: {
    onAdd() {
            if(this.$ls.get('token')){
              this.visible=true;
            }
            this.form.contact=null,
            this.form.contactNumber=null,
            this.form.applicationRemarks=null
    },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
:deep(.ant-tag){
  background: #e4e6fc;
  border-radius: 2px;
  border:none;
  padding:2px 10px;
}
.list_cont{
  width: 100%;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 100px;
    height: 100px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 20px 20px 20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
        span{
          margin-right:20px;
          i{
            font-style: normal;
            color:red
          }
        }
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      background: #1890ff;
      color:#fff
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>
